// extracted by mini-css-extract-plugin
export default {"wrapper":"Place_wrapper__WV87I","card":"Place_card__PbAj9","row":"Place_row__jAQRK","location":"Place_location__yKImG"};